var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 21.75c-4.94 0-7.05-2.11-7.05-7.05V9.3c0-4.94 2.11-7.05 7.05-7.05h5.4c4.94 0 7.05 2.11 7.05 7.05v5.4c0 4.94-2.11 7.05-7.05 7.05H9.3zM3.75 9.3v5.4c0 4.1 1.45 5.55 5.55 5.55h5.4c4.1 0 5.55-1.45 5.55-5.55V9.3c0-4.1-1.45-5.55-5.55-5.55H9.3c-4.1 0-5.55 1.45-5.55 5.55z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineStop);
export default __webpack_public_path__ + "static/media/vuesax-outline-stop.8472b2134671b1f01372eac2c3d5e7f4.svg";
export { ForwardRef as ReactComponent };